export enum JobRequirementOptionTypeEnum {
  FieldOfStudy = 'FIELD_OF_STUDY',
}
